import { NgModule } from "@angular/core";
import { ExamplesComponent } from "@webapp/examples/examples.component";
import { UiModule } from "@webapp/ui/ui.module";
import { ExampleButtonsComponent } from "@webapp/examples/example-buttons/example-buttons.component";
import { ExampleIconsComponent } from "@webapp/examples/example-icons/example-icons.component";
import { ExampleWhiteboardComponent } from "@webapp/examples/example-whiteboards/example-whiteboard/example-whiteboard.component";
import { ExampleWhiteboardsComponent } from "@webapp/examples/example-whiteboards/example-whiteboards.component";
import { CommonModule } from "@angular/common";
import { ExampleDrawerComponent } from "@webapp/examples/example-drawer/example-drawer.component";
import { TestDrawerComponent } from "@webapp/examples/example-drawer/test-drawer-component/test-drawer.component";
import { ExampleModalComponent } from "@webapp/examples/example-modals/example-modal.component";
import { TestModalComponent } from "@webapp/examples/example-modals/test-modal/test-modal.component";
import { ExampleDividerComponent } from "./example-divider/example-divider.component";
import { ExamplePopoverComponent } from "@webapp/examples/example-popover/example-popover.component";
import { ExampleSpinComponent } from "./example-spin/example-spin.component";
import { ExampleMenuComponent } from "@webapp/examples/example-menu/example-menu.component";
import { ExamplePermissionsComponent } from "@webapp/examples/example-permissions/example-permissions.component";
import { ExamplesRoutingModule } from "@webapp/examples/examples-routing.module";
import { ExampleSelectComponent } from "@webapp/examples/example-select/example-select.component";
import { FormsModule } from "@angular/forms";
import { ExampleGridComponent } from "@webapp/examples/example-grid/example-grid.component";
import { NzSliderModule } from "ng-zorro-antd/slider";

@NgModule({
  declarations: [
    ExamplesComponent,
    ExampleWhiteboardComponent,
    ExampleWhiteboardsComponent,
    ExampleIconsComponent,
    ExampleDrawerComponent,
    TestDrawerComponent,
    ExampleButtonsComponent,
    ExampleModalComponent,
    TestModalComponent,
    ExamplePopoverComponent,
    ExampleDividerComponent,
    ExampleSpinComponent,
    ExampleMenuComponent,
    ExamplePermissionsComponent,
    ExampleGridComponent,
    ExampleSelectComponent,
  ],
  imports: [CommonModule, ExamplesRoutingModule, UiModule, FormsModule, NzSliderModule],
})
export class ExamplesModule {}
